import React, { useEffect, useState } from "react";
import { DialogComponent } from "../common/DialogComponent";
import AlertDetails from "../Dialogs/AlertDetails";
import { useDispatch, useSelector } from "react-redux";
import * as alertActions from "../../store/AlertsService/actions";
import { ApplicationState } from "../../store";
import CreditAlert from "../Monitoring/CreditAlert";
import L3ContinueComponent from "../Credit/L3/L3ContinueComponent";
import i18nService from "../../util/Internationalization/i18n/i18n";
import AlertDetailContainer from "../Monitoring/AlertDetailContainer";
import AlertL3Dialog from "./AlertL3Dialog";
import { getFormattedDate } from "../../util/dateFormatting";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";
import { useTranslation } from "react-i18next";

const DashboardAlerts = () => {
    const dispatch = useDispatch();
    const {
        showAlertDetails,
        setShowAlertDetails,
        yScroll,
        alertDetails,
        alert,
        l3Auth,
        setL3Auth,
        creditAlertDetailsCallback,
        isIDFuser,
        csidUserStatus,
        showCreditAuth,
        creditAuthSuccessCallBack,
        closeDisclosureDialogCallBack,
    } = AlertDetailContainer();
    const isBusinessUser = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userServiceDetails && state.loggedInUser.userServiceDetails.isBusinessUser
            ? state.loggedInUser.userServiceDetails.isBusinessUser
            : false
    );
    const { t: tLang } = useTranslation();
    const [refresh, setRefresh] = useState(true);
    const [alertsLength, setAlertsLength] = useState(5);
    const requestAlertData = (reload: boolean) => dispatch(alertActions.actionCreators.getAlertData(isBusinessUser, reload));
    const alerts: any = useSelector((state: ApplicationState) => (state.alertState && state.alertState.alertData ? state.alertState.alertData : []));
    const loading = useSelector((state: ApplicationState) => (state.alertState ? state.alertState.isAlertLoading : false));
    const [messageKeyForInitialL3Continue] = useState("credit-service");
    const [showInitialContinue, setShowInitialContinue] = useState(false);

    useEffect(() => {
        if (refresh) {
            requestAlertData(true);
            setRefresh(false);
        }
    }, [refresh === true]);

    useEffect(() => {
        requestAlertData(false);
    }, []);

    const toggleAlertList = () => {
        if (alerts.length > 5) {
            if (alertsLength === 5) {
                setAlertsLength(alerts.length);
            } else {
                setAlertsLength(5);
            }
        }
    };

    const handleCloseDialog = (): any => {
        setShowAlertDetails(false);
        if (l3Auth) {
            window.location.reload();
        }else{
            setTimeout(()=>{
                scrollTo(0, yScroll)
            })
        }
    };

    const initialContinueSubmitCallBack = (callbackObj: any) => {
        setShowInitialContinue(false);
        setL3Auth(true);
    };

    const closeInitialContinue = () => {
        setShowInitialContinue(false);
    };

    const needShowingCrossButton = (alrt: any): boolean => {
        return alrt["serviceType"] !== "SEXOFF-FWD";
    };

    return (
        <>
            {loading ? (
                <div className="box loading"></div>
            ) : (
                <ul id="alert-list">
                    {alerts &&
                        alerts.length > 0 &&
                        alerts
                            .filter(
                                (alert: any) =>
                                    (
                                    alert.alertStatus === "NEW" ||
                                    alert.alertStatus === "New" ||
                                    alert.alertStatus === "Viewed" ||
                                    alert.alertStatus === "GOOD_ALERT" ||
                                    alert.alertStatus === "VIEWED"  
                                    ) &&
                                    (alert.serviceType !== "SubscriptionEnded")
                            )
                            .map((alert: any, index: number) => {
                                return (
                                    <>
                                        {index < alertsLength && (
                                            <li key={alert.alertID} onClick={() => alertDetails(alert)}>
                                                <div className={`dashboard-alert-container ${alert.alertStatus === "GOOD_ALERT" ? "good-alert" : "status-alert"}`}>
                                                    <a href="javascript:void(0)">
                                                        <span className="row">
                                                            <span className="col-xs col-no-gutter flex-grow-null">
                                                                <span className="dashboard-alert-icon">
                                                                    {!(alert.alertStatus === "GOOD_ALERT") ? (
                                                                        <em className="las la-exclamation-triangle"></em>
                                                                    ) : (
                                                                        <RenderIcons iconName="dashboard-good-alert" />
                                                                    )}
                                                                </span>
                                                            </span>
                                                            <span className="col-xs col-no-gutter">
                                                                <span className="dashboard-alert-description">
                                                                    <span className="sr-only">Critical Alert</span>
                                                                    {(isBusinessUser ? "Business " : "") + alert.displayName}
                                                                </span>
                                                            </span>

                                                            <span className="col-xs col-no-gutter flex-grow-null">
                                                                <span className="dashboard-alert-date">
                                                                    <span className="sr-only">Alert Date:</span>
                                                                   {alert.createdDate && getFormattedDate(i18nService.get("Country"), alert.createdDate)}
                                                                </span>
                                                            </span>
                                                        </span>
                                                    </a>
                                                </div>
                                            </li>
                                        )}
                                    </>
                                );
                            })}
                    {alerts &&
                        alerts.length > 0 &&
                        alerts.filter(
                            (alert: any) =>
                                (alert.alertStatus === "NEW" ||
                                alert.alertStatus === "New" ||
                                alert.alertStatus === "Viewed" ||
                                alert.alertStatus === "GOOD_ALERT" ||
                                alert.alertStatus === "VIEWED") &&
                                (alert.serviceType !== "SubscriptionEnded")
                                //servicetype 
                        ).length > 5 && (
                            <li>
                                <span>
                                    <a href="javascript:void(0)" onClick={() => toggleAlertList()} className="default_link">
                                        {`${alertsLength > 5 ? tLang("hide.title") : tLang("dashboard.seeMore") }`}
                                    </a>
                               </span>
                            </li>
                        )}
                </ul>
            )}
            {showAlertDetails && (
                <DialogComponent
                    hideCloseButton={needShowingCrossButton(alert)}
                    dialogId="alert-details-dialog"
                    title="Alert Details"
                    closeDialog={handleCloseDialog}
                >
                    <AlertDetails refresh={setRefresh} alert={alert} />
                </DialogComponent>
            )}
            {showInitialContinue && (
                <DialogComponent dialogId="dialog-l3-disclosure" title="L3 Disclosure" closeDialog={closeInitialContinue} hideCloseButton={false}>
                    <div className="dialog-body">
                        <L3ContinueComponent
                            submitButtonText={"Try verification again"}
                            onSubmitCallback={initialContinueSubmitCallBack}
                            messageKey={messageKeyForInitialL3Continue}
                            openAsDialog={true}
                            closeButtonText={"Close"}
                            onCloseCallback={closeInitialContinue}
                            continueFlowWithL3={true}
                        ></L3ContinueComponent>
                    </div>
                </DialogComponent>
            )}

            {l3Auth && <CreditAlert triggeredFrom="Dashboard" setL3Auth={setL3Auth} alertDetails={alert} creditAlertDetailsCallback={creditAlertDetailsCallback} />}

            <AlertL3Dialog
                showCreditAuth={showCreditAuth}
                csidUserStatus={csidUserStatus}
                closeDisclosureDialogCallBack={closeDisclosureDialogCallBack}
                creditAuthSuccessCallBack={creditAuthSuccessCallBack}
                isIDFuser={isIDFuser}
            />
        </>
    );
};

export default DashboardAlerts;

// function current(current: any, arg1: (any: any) => any[]) {
//     throw new Error("Function not implemented.");
// }
